import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import type { UserProfile } from "@/services/api/userProfile";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { fetchUserProfile } from "@/store/slices/profileSlice";

export interface ProfileOutletContext {
  profile: UserProfile | null;
  isLoading: boolean;
  error: string | null;
}

const FALLBACK_PROFILE_STATE: ProfileOutletContext = {
  profile: null,
  isLoading: false,
  error: null,
};

const ProfileLayout = () => {
  const dispatch = useAppDispatch();
  const profileState =
    useAppSelector((state) => state.profile) ?? FALLBACK_PROFILE_STATE;

  useEffect(() => {
    if (!profileState.profile && !profileState.isLoading) {
      dispatch(fetchUserProfile());
    }
  }, [dispatch, profileState.isLoading, profileState.profile]);


  return (
    <Outlet
      context={{
        profile: profileState.profile,
        isLoading: profileState.isLoading,
        error: profileState.error,
      }}
    />
  );
};

export default ProfileLayout;
